<template>
  <div class="layout flex h-full w-full" :class="{ 'login-layout': isLoginPage }">
    <div
      v-if="router.currentRoute.value.name !== 'Login'"
      class="left-side-bar shrink-0 py-[12px] flex flex-col items-center justify-between"
      :class="{ 'collapsed-nav': isNavCollapsed }"
      @mouseenter="expandNav"
      @mouseleave="collapseNav"
    >
      <div class="flex flex-col items-center w-full">
        <!-- Logo区域 -->
        <div class="logo-container mb-[15px] flex items-center px-[10px]">
          <div class="app-logo flex items-center justify-center rounded-[8px]">
            <span class="text-[18px] font-bold">U</span>
          </div>
          <template v-if="!isNavCollapsed">
            <span class="logo-text ml-[4px] text-[16px] font-medium">优创</span>
            <div class="back-btn ml-auto cursor-pointer">
              <el-icon><ArrowLeft /></el-icon>
            </div>
          </template>
        </div>

        <!-- 导航菜单 -->
        <div class="nav-menu w-full px-[10px]">
          <div
            @click="goIndex"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'Home' }"
          >
            <el-icon class="nav-icon"><EditPen /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">脚本智写</span>
            </template>
          </div>
          <div
            @click="goSpeechSynthesis"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'speechSynthesis' }"
          >
            <el-icon class="nav-icon"><Microphone /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">语音智合</span>
            </template>
          </div>
          <div
            @click="goNovels"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'batchNovels' }"
          >
            <el-icon class="nav-icon"><DocumentCopy /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">小说快剪</span>
            </template>
          </div>
          <div
            @click="goBactchCutout"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'batchCutout' }"
          >
            <el-icon class="nav-icon"><Picture /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">图片快修</span>
            </template>
          </div>
          <div
            @click="goImageAIGenerator"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'imageAIGenerator' }"
          >
            <el-icon class="nav-icon"><PictureFilled /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">图文智绘</span>
            </template>
          </div>
          <div
            @click="goConvertVideo"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'convertVideo' }"
          >
            <el-icon class="nav-icon"><VideoCamera /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">视频快改</span>
            </template>
          </div>
          <div
            @click="goJingDong"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'jingDong' }"
          >
            <el-icon class="nav-icon"><TrendCharts /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">智能混剪</span>
            </template>
          </div>

          <div
            @click="goBatchShortPlay"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'batchShortPlay' }"
          >
            <el-icon class="nav-icon">
              <svg-icon name="shortplay" width="16px" height="16px" color="#cdcdcd" />
            </el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">短剧快剪</span>
            </template>
          </div>
		     <div
            @click="goGetMaterials"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'getMaterials' }"
          >
            <el-icon class="nav-icon"><MostlyCloudy /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">素材获取</span>
            </template>
          </div>
          <!-- <div
            @click="goTaskStatistics"
            class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
            :class="{ 'active-nav-item': router.currentRoute.value.name === 'taskStatistics' }"
          >
            <el-icon class="nav-icon"><Histogram /></el-icon>
            <template v-if="!isNavCollapsed">
              <span class="text-[14px] title font-medium">任务统计</span>
            </template>
          </div> -->
        </div>
      </div>
      <div class="w-full px-[10px]">
        <div
          @click="goFavorites"
          class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
          :class="{ 'active-nav-item': router.currentRoute.value.name === 'favorites' }"
        >
          <el-icon class="nav-icon"><Star /></el-icon>
          <template v-if="!isNavCollapsed">
            <span class="text-[14px] title font-medium">收藏夹</span>
          </template>
        </div>
        <div
          class="nav-item flex cursor-pointer mb-[8px] items-center gap-[4px] p-[10px] rounded-[12px]"
        >
          <div class="user-avatar flex items-center justify-center gradient-bg">
            <span class="text-white font-medium text-[14px]">{{ userName.charAt(0) }}</span>
          </div>
          <template v-if="!isNavCollapsed">
            <span class="username">{{ userName }}</span>
          </template>
        </div>
      </div>
    </div>
    <div class="flex-grow overflow-hidden">
      <div class="content h-full w-full relative p-[8px]">
        <div class="rounded-[12px] h-full w-full overflow-hidden bg-white flex shadow-container">
          <div
            v-show="isShowTask"
            :class="[
              'w-[260px] duration-300 flex overflow-hidden opacity-100 ',
              {
                'collapsed shrink-0': layoutStore.sidebarCollapsed,
                hide_task_list: layoutStore.isHideTaskList
              }
            ]"
          >
            <div>
              <div
                :class="[
                  'w-[260px] bg-white shrink-0  py-[24px] z-[11] select-none box-border flex flex-col gap-[16px] h-full'
                ]"
              >
                <CreateTask />
                <div class="flex-grow overflow-hidden">
                  <TaskList />
                </div>
                <div
                  class="flex flex-col justify-center items-center gap-[10px] px-[10px]"
                  @click="handleBatchDelete"
                >
                  <div class="border-horizontal bg-[#e2e2e2]"></div>
                  <div
                    class="text-[14px] w-fit-content text-[#1c1c1e] hover:text-[#6a50fd] duration-300 cursor-pointer flex gap-[4px] justify-center items-center h-[32px] rounded-[4px]"
                  >
                    <el-icon><i-ep-list /></el-icon>批量管理任务
                  </div>
                </div>
              </div>
            </div>
            <div class="flex items-center px-[20px] pr-[5px] relative dialog-wrapper">
              <div class="box-border overflow-y-auto dialog-wrap custom-scroll">
                <div class="h-full">
                  <div
                    class="dialog-mask flex w-full h-full justify-center items-center"
                    v-if="layoutStore.dialogLoadingRef"
                  >
                    <div class="flex justify-center items-center flex-col gap-[10px]">
                      <LoadIcon></LoadIcon>
                      <p class="text-[12px] text-[#ccc]">模版准备中...</p>
                    </div>
                  </div>
                  <div v-else class="h-full">
                    <Dialog :key="taskStore.currentTaskDetail.id" v-if="shouldShowDialog"></Dialog>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="bg-[#f9faff] flex mr-0 h-full container-content overflow-hidden flex-1 items-center content-area"
          >
            <el-tooltip
              class="box-item"
              effect="dark"
              :content="calcText"
              placement="right"
              :show-arrow="false"
              v-if="router.currentRoute.value.name === 'Home'"
            >
              <div
                @click="handleHideTaskList"
                :class="[
                  ' hide_task_list_icon translate-y-[-50%] cursor-pointer origin-center ',
                  {
                    'rotate-180': layoutStore.isHideTaskList
                  }
                ]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  version="1.1"
                  width="5.997314453125"
                  height="28.001953125"
                  viewBox="0 0 5.997314453125 28.001953125"
                  data-spm-anchor-id="5176.28103460.0.i13.6c3e3da2jf7fWR"
                >
                  <g>
                    <g>
                      <path
                        d="M1.76479,1.83999484375L0.0229461,13.55206484375Q-0.0106777,13.77816484375,0.00468256,14.00546484375Q-0.00940751,14.22826484375,0.0235386,14.44976484375L1.76538,26.16176484375Q1.78073,26.26496484375,1.80613,26.36626484375Q1.83154,26.46766484375,1.86676,26.56616484375Q1.90198,26.66466484375,1.94667,26.75946484375Q1.99137,26.85416484375,2.04511,26.94426484375Q2.09885,27.03426484375,2.16112,27.11886484375Q2.22339,27.20336484375,2.29359,27.28156484375Q2.36379,27.35966484375,2.44124,27.43076484375Q2.51869,27.50176484375,2.60264,27.56506484375Q2.6866,27.62826484375,2.77625,27.68316484375Q2.86591,27.73796484375,2.96039,27.78386484375Q3.05488,27.82976484375,3.1533,27.86626484375Q3.25171,27.90286484375,3.3531,27.92966484375Q3.45449,27.95646484375,3.55788,27.97326484375Q3.66127,27.99006484375,3.76566,27.99676484375Q3.87005,28.00336484375,3.97445,27.99986484375Q4.07884,27.99626484375,4.18223,27.98256484375Q4.38946,27.95506484375,4.58672,27.88766484375Q4.78398,27.82036484375,4.96367,27.71576484375Q5.14337,27.61126484375,5.29861,27.47346484375Q5.45384,27.33566484375,5.57866,27.17006484375Q5.70352,27.00426484375,5.79313,26.81696484375Q5.88274,26.62966484375,5.93366,26.42796484375Q5.98459,26.22626484375,5.99486,26.01796484375Q6.00513,25.80966484375,5.97436,25.60276484375L4.2486,13.99886484375L5.97378,2.39897484375Q6.00455,2.19207484375,5.99427,1.98378484375Q5.984,1.77549484375,5.93308,1.57381484375Q5.88215,1.37214484375,5.79254,1.18482484375Q5.70293,0.99751484375,5.57807,0.83176884375Q5.45325,0.66608384375,5.29802,0.52831484375Q5.14278,0.39054584375,4.96308,0.28598684375Q4.78339,0.18142684375,4.58613,0.11409284375Q4.38888,0.04675804375,4.18164,0.01923584375Q4.07825,0.00550537375Q3.97386,0.00195430175Q3.86947,-0.0015967662500000002,3.76507,0.005065743750000001Q3.66068,0.01172824375,3.55729,0.02854014375Q3.4539,0.04535214375,3.35251,0.07215154375Q3.25112,0.09895094375,3.15271,0.13547984375Q3.05429,0.17200884375,2.95981,0.21791484375Q2.86532,0.26382184375,2.77566,0.31866384375Q2.68601,0.37350584375,2.60205,0.43675484375Q2.5181,0.5000038437500001,2.44065,0.57105184375Q2.3632,0.64209984375,2.293,0.72026084375Q2.2228,0.79842284375,2.16053,0.88294584375Q2.09826,0.96746784375,2.04452,1.05753484375Q1.99078,1.14760484375,1.94608,1.24235484375Q1.90139,1.33710484375,1.86617,1.43562484375Q1.83095,1.53414484375,1.80554,1.63547484375Q1.78014,1.73681484375,1.76479,1.83999484375Z"
                        fill-rule="evenodd"
                        fill-opacity="1"
                        data-spm-anchor-id="5176.28103460.0.i12.6c3e3da2jf7fWR"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
            </el-tooltip>
            <router-view />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="isShowBatchDelete"
      title="Tips"
      width="800"
      :before-close="handleClose"
      class="rounded-[10px]"
    >
      <template #header>
        <div class="flex justify-between">
          <div class="shrink-0">管理任务列表 . 共 {{ taskLength }} 条</div>

          <el-input
            v-model="searchKey"
            size="default"
            placeholder="搜索对话"
            clearable
            class="taskList-search-wrap"
          >
            <template #prepend>
              <el-icon><i-ep-search /></el-icon>
            </template>
          </el-input>
        </div>
      </template>

      <el-table
        :data="taskList"
        style="width: 100%"
        height="500"
        header-cell-class-name="font-normal text-[#1c1c1e] text-[14px]"
        cell-class-name="text-[13px]"
      >
        <el-table-column
          :type="column.type"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          v-for="(column, _index) in taskTableColumns"
          :key="_index"
        >
          <template #header v-if="column.prop === 'checkbox'">
            <div class="cursor-pointer" @click="handleCheckALl">
              <img :src="getImgUrl" />
            </div>
          </template>
          <template #header v-else-if="column.label === '操作'">
            <span class="w-full text-center">操作</span>
          </template>

          <template #default="{ row }" v-if="column.label === '操作'">
            <el-popconfirm
              width="280"
              title="确定要删除这个任务吗？"
              confirm-button-text="删除"
              cancel-button-text="取消"
              @confirm="handleDelete(row)"
            >
              <template #reference>
                <span class="flex items-center gap-[4px] cursor-pointer hover:text-[red]">
                  <el-icon><i-ep-delete /></el-icon>删除
                </span>
              </template>
            </el-popconfirm>
          </template>

          <template #default="{ row }" v-else-if="column.prop === 'create_time'">
            <span>
              {{ row.create_time ? dayjs(row.create_time).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </span>
          </template>
          <template #default="{ row }" v-else-if="column.prop === 'checkbox'">
            <div class="cursor-pointer" @click="handleItemCheck(row)">
              <img :src="waitToDeleteIds[row.id] ? bodyCheckAllUrl : bodyCheckUrl" />
            </div>
          </template>

          <template #default="{ row }" v-else>
            <span>
              {{ row[column.prop] }}
            </span>
          </template>
        </el-table-column>

        <template #empty>
          <el-empty description="还没有创建任务" />
        </template>
      </el-table>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>

          <el-popconfirm
            :title="'本次共选中' + Object.keys(waitToDeleteIds).length + '条, 确认要删除吗？'"
            width="280"
            confirm-button-text="删除"
            cancel-button-text="取消"
            @confirm="handleConfirmBatchDelete()"
          >
            <template #reference>
              <el-button
                :disabled="!Object.keys(waitToDeleteIds).length"
                type="danger"
                @click="dialogVisible = false"
                >删除所选</el-button
              >
            </template>
          </el-popconfirm>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { useTaskStore } from '../../store/taskStore'
import { useLayoutStore } from '../../store/layoutStore'
import { batchDelete, taskDelete } from '../../service/task'
import { useRouter } from 'vue-router'
import bodyCheckAllUrl from '../../assets/bodycheckall.png'
import bodyCheckHalfUrl from '../../assets/header-check-half.png'
import bodyCheckUrl from '../../assets/bodycheck.png'
import { useUserInfoStore } from '../../store/userInfo'
import {
  VideoCamera,
  DocumentCopy,
  EditPen,
  Picture,
  Microphone,
  Tools,
  Star,
  ArrowLeft,
  MostlyCloudy,
  Histogram,
  Film,
  PictureFilled,
  TrendCharts
} from '@element-plus/icons-vue'
import dayjs from 'dayjs'
import { ref, computed } from 'vue'

// 新增直接设置图标白色样式的CSS
const styleElement = document.createElement('style')
styleElement.textContent = `
  .active-nav-item .nav-icon {
    // color: white !important;
  }
`
document.head.appendChild(styleElement)

const router = useRouter()
console.log('router', router.currentRoute.value.name)
const taskStore = useTaskStore()
const layoutStore = useLayoutStore()
const userInfoStore = useUserInfoStore()
const isShowBatchDelete = ref(false)
const searchKey = ref('')
const isNavCollapsed = ref(true) // 默认导航栏处于收起状态

const expandNav = () => {
  // 使用requestAnimationFrame确保动画流畅
  requestAnimationFrame(() => {
    isNavCollapsed.value = false
  })
}

const collapseNav = () => {
  // 使用requestAnimationFrame确保动画流畅
  requestAnimationFrame(() => {
    isNavCollapsed.value = true
  })
}

const taskList = computed(() => {
  const copyTasks = { ...taskStore.rawTasks }
  return Object.values(copyTasks).filter((task) => {
    return task.name.includes(searchKey.value)
  })
})

const isShowTask = computed(() => {
  return (
    router.currentRoute.value.name !== 'Login' &&  
    router.currentRoute.value.name !== 'favorites' &&
    router.currentRoute.value.name !== 'batchCutout' &&
    router.currentRoute.value.name !== 'navigation' &&
    router.currentRoute.value.name !== 'speechSynthesis' &&
    router.currentRoute.value.name !== 'batchNovels' &&
    router.currentRoute.value.name !== 'convertVideo' &&
    router.currentRoute.value.name !== 'workflow' &&
    router.currentRoute.value.name !== 'getMaterials' &&
    router.currentRoute.value.name !== 'taskStatistics' &&
    router.currentRoute.value.name !== 'imageAIGenerator' &&
    router.currentRoute.value.name!== 'jingDong' &&
    router.currentRoute.value.name !== 'batchShortPlay'
  )
})

const goFavorites = () => {
  router.push({ name: 'favorites' })
}

const goBactchCutout = () => {
  router.push({ name: 'batchCutout' })
}

const goSpeechSynthesis = () => {
  router.push({ name: 'speechSynthesis' })
}

const goIndex = () => {
  router.push('/')
}

const goNavigation = () => {
  router.push({ name: 'navigation' })
}

const goWorkflow = () => {
  router.push({ name: 'workflow' })
}

const goNovels = () => {
  router.push({ name: 'batchNovels' })
}
const goConvertVideo = () => {
  router.push({ name: 'convertVideo' })
}
const goImageAIGenerator = () => {
  router.push({ name: 'imageAIGenerator' })
}
const goJingDong = () => {
  router.push({ name: 'jingDong' })
}
const goGetMaterials = () => {
  router.push({ name: 'getMaterials' })
}
const goTaskStatistics = () => {
  router.push({ name: 'taskStatistics' })
}

const goBatchShortPlay = () => {
  router.push({ name: 'batchShortPlay' })
}
const checkStatus = ref('none')
const userInfo = computed(() => {
  return userInfoStore.userInfo
})
const isLoginPage = computed(() => {
  return router.currentRoute.value.name === 'Login'
})

const userName = computed(() => {
  const name = userInfo.value?.name
  if (typeof name === 'string' && name.length >= 4) {
    return name.substring(0, 4)
  } else {
    return name ? name.substring(0, name.length) : '' // 防止name为null
  }
})

const headerCheckBoxImgUrl = {
  all: bodyCheckAllUrl,
  half: bodyCheckHalfUrl,
  none: bodyCheckUrl
}
const getImgUrl = computed(() => {
  return headerCheckBoxImgUrl[checkStatus.value]
})

const checkAll = ref(false)
const waitToDeleteIds = ref({})

const handleCheckALl = () => {
  checkAll.value = !checkAll.value
  if (checkAll.value) {
    checkStatus.value = 'all'
    waitToDeleteIds.value = taskList.value.reduce((acc, cur) => {
      acc[cur.id] = true
      return acc
    }, {})
  } else {
    checkStatus.value = 'none'
    waitToDeleteIds.value = {}
  }
}

const currentTaskStatus = ref('')

const itemChange = (item) => {
  currentTaskStatus.value = item.status // 当前任务的状态
}

const handleItemCheck = (row) => {
  if (waitToDeleteIds.value[row.id]) {
    delete waitToDeleteIds.value[row.id]
  } else {
    waitToDeleteIds.value[row.id] = true
  }

  if (Object.keys(waitToDeleteIds.value).length === taskList.value.length) {
    checkStatus.value = 'all'
    checkAll.value = true
  } else if (Object.keys(waitToDeleteIds.value).length === 0) {
    checkStatus.value = 'none'
    checkAll.value = false
  } else {
    checkStatus.value = 'half'
    checkAll.value = false
  }
}

const resetCheckData = () => {
  checkAll.value = false
  checkStatus.value = 'none'
  waitToDeleteIds.value = {}
}

const closeDialog = () => {
  isShowBatchDelete.value = false
  resetCheckData()
}

const taskTableColumns = [
  {
    title: '',
    prop: 'checkbox',
    width: 44
  },
  {
    prop: 'name',
    label: '任务名称',
    width: 180
  },
  {
    prop: 'create_time',
    label: '创建时间'
  },
  {
    label: '操作',
    width: 100
  }
]

const taskLength = computed(() => {
  return Object.keys(taskStore.rawTasks).length
})

const handleDelete = async (row) => {
  const { code } = await taskDelete(row.id)
  if (code === 0) {
    taskStore.deleteTask(row.id)

    if (row.id === taskStore.currentTaskDetail.id) {
      // 如果删除的是当前激活的任务
      taskStore.setCurrentTaskDetail({})

      layoutStore.showResults = false
    }

    delete waitToDeleteIds.value[row.id]
  }
}

const handleConfirmBatchDelete = async () => {
  const { code } = await batchDelete(Object.keys(waitToDeleteIds.value))
  if (code === 0) {
    Object.keys(waitToDeleteIds.value).forEach((id) => {
      taskStore.deleteTask(id)
    })
    waitToDeleteIds.value = {}
    isShowBatchDelete.value = false
  }
}

const handleClose = () => {
  isShowBatchDelete.value = false
}

const handleBatchDelete = () => {
  isShowBatchDelete.value = true
}

const handleHideTaskList = () => {
  layoutStore.isHideTaskList = !layoutStore.isHideTaskList
}

const calcText = computed(() => {
  return layoutStore.isHideTaskList ? '展开任务列表' : '收起任务列表'
})

const shouldShowDialog = computed(() => {
  if (taskStore.currentTaskDetail?.advanced && taskStore.currentTaskDetail?.content) {
    return true
  } else {
    return false
  }
})
</script>

<style lang="scss" scoped>
:root {
  --primary-purple: #d585ff;
  --primary-purple-light: #f1d5ff;
  --primary-blue: #74bdff;
  --primary-green: #00ffee;
  --text-dark: #333333;
  --text-light: #666666;
  --background-light: #f8f9ff;
  --border-color: #e0e6ff;
  --shadow-color: rgba(213, 133, 255, 0.1);
}

.logo-text,
.back-btn,
.title,
.username {
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 1;
  transform: translateX(0);
  visibility: visible;
  pointer-events: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

:deep(.search-wrap .el-input__wrapper:hover) {
  box-shadow: none;
}

.layout {
  height: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      var(--background-light) 0%,
      rgba(205, 210, 255, 0.4) 50%,
      rgba(195, 225, 255, 0.35) 100%
    );
    background-position: left center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: -1;
  }

  .left-side-bar {
    width: 160px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    color: #333;
    transition: width 0.25s ease;
    position: relative;
    z-index: 100;
    overflow: hidden;
    will-change: width, transform;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translateZ(0);
    backface-visibility: hidden;
  }

  .collapsed-nav {
    width: 70px;

    .logo-text,
    .back-btn,
    .title,
    .username {
      opacity: 0;
      transform: translateX(-10px);
      transition: opacity 0.25s ease, transform 0.25s ease;
      visibility: hidden;
      pointer-events: none;
    }

    .user-badge {
      justify-content: center;
      transition: all 0.25s ease 0.25s;

      .user-avatar {
        margin: 0 auto;
        transition: margin 0.25s ease 0.25s;
      }
    }
  }

  .logo-container {
    width: 100%;
    position: relative;
    height: 36px;
    justify-content: flex-start;
    padding: 0 15px;

    .app-logo {
      width: 36px;
      height: 36px;
      margin: 0;
      background: linear-gradient(135deg, rgba(128, 135, 255, 1), rgba(116, 189, 255, 1));
      color: white;
      border-radius: 8px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      position: relative;
    }

    .logo-text {
      color: #333;
      font-weight: 600;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      transition-delay: 0.05s;
      opacity: 1;
      transform: translateX(0);
      visibility: visible;
      white-space: nowrap;
      position: relative;
      margin-left: 8px;
      z-index: 1;
    }

    .back-btn {
      color: #6577ff;
      font-size: 18px;
      position: absolute;
      right: 15px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      transition-delay: 0.05s;
      opacity: 1;
      transform: translateX(0);
      visibility: visible;
      white-space: nowrap;
    }
  }

  .nav-menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding: 0 10px;
  }

  .nav-item {
    transition: background 0.15s ease;
    position: relative;
    width: 100%;
    max-width: 140px;
    color: #333;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
    margin: 0 auto 8px;

    .nav-icon {
      font-size: 18px;
      width: 32px;
      height: 32px;
      min-width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background: transparent;
      color: rgb(60, 60, 60);
      transition: none;
      flex-shrink: 0;
      margin-right: 2px;
    }

    .title {
      font-size: 14px;
      white-space: nowrap;
      margin-left: 0;
      transition: none;
    }

    &:hover {
      background: rgba(101, 119, 255, 0.05);
    }

    &.active-nav-item {
      background: linear-gradient(135deg, rgba(144, 150, 255, 1), rgba(133, 200, 255, 1));
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(116, 189, 255, 0.3);
      color: white;

      .nav-icon {
        background: transparent !important;
        color: white !important;
        box-shadow: none !important;
        transition: none !important;
      }

      .title {
        color: white;
      }
    }

    .title {
      position: static;
      margin-left: 12px;
      transition: none;
      color: #333;
      font-weight: 400;
      white-space: nowrap;
      opacity: 1;
      transform: translateX(0);
      visibility: visible;
    }
  }

  .nav-icon {
    font-size: 18px;
    width: 32px;
    height: 32px;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: transparent;
    color: rgb(60, 60, 60);
    transition: none;
    flex-shrink: 0;
    margin: 0;
    transform: translateZ(0);
    backface-visibility: hidden;
    will-change: transform, margin, color;
  }

  .user-badge {
    background: rgba(101, 119, 255, 0.05);
    color: #333;
    font-size: 14px;
    transition: all 0.25s ease;
    cursor: pointer;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    width: 100%;
    padding: 8px 10px;

    .user-avatar {
      margin-right: auto;
      transition: margin 0.25s ease;
    }
  }

  .username {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0.05s;
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
    position: static;
    margin-left: 8px;
    font-size: 14px !important;
    font-weight: 400;
  }

  .user-avatar {
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 6px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  .gradient-bg {
    background: linear-gradient(135deg, rgba(128, 135, 255, 1), rgba(116, 189, 255, 1));
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
      z-index: 1;
    }

    span {
      position: relative;
      z-index: 2;
    }
  }

  .collapsed {
    width: 650px;
  }

  .dialog-wrapper {
    width: 100%;
    box-shadow: inset 5px 0 5px -5px rgba(0, 0, 0, 0.1), inset -5px 0 5px -5px rgba(0, 0, 0, 0.1);
  }

  .menu-wrap {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .custom-scroll {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f5f4ff;
      border-radius: 3px;
    }
  }

  .dialog-wrap {
    padding: 24px 0;
    width: 100%;
    height: 100%;
  }

  .mask-top-bottom {
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 100), rgba(255, 255, 255, 0));
    position: absolute;
    top: 20px;
    left: 15px;
    right: 15px;
    z-index: 1;
    pointer-events: none;
  }

  .mask-bottom {
    background-image: linear-gradient(to top, rgba(255, 255, 255, 100), rgba(255, 255, 255, 0));
    position: absolute;
    bottom: 20px;
    left: 15px;
    right: 15px;
    z-index: 1;
    pointer-events: none;
  }

  .taskList-search-wrap {
    width: 200px;
  }

  .hide_task_list {
    transition: all 0.3s;
    width: 0px;
    opacity: 0;
  }

  .hide_task_list_icon {
    padding: 0 10px;

    svg {
      fill: var(--primary-purple-light);
    }
  }
}

.shadow-container {
  box-shadow: 0 4px 20px rgba(122, 137, 255, 0.1);
  border: 1px solid rgba(230, 232, 255, 0.8);
  background-color: rgba(255, 255, 255, 0.95);
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover {
    box-shadow: 0 6px 24px rgba(122, 137, 255, 0.15);
  }
}

.bg-\[\#f9faff\] {
  transition: background-color 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover {
    background-color: #f7f8ff;
  }
}

.content-area {
  transition: background-color 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover {
    background-color: #f7f8ff;
  }
}
</style>

<style>
/* 添加登录页面专用样式 */
.login-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7ff 0%, #f1f4ff 100%);
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
}

.login-layout .content {
  padding: 0 !important;
  background: transparent !important;
}

.login-layout .router-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 确保登录页面不显示任何其他元素 */
.login-layout .left-side-bar,
.login-layout .dialog-wrapper,
.login-layout .hide_task_list_icon {
  display: none !important;
}

/* 修复登录页面内容区域样式 */
.login-layout .content .rounded-[12px] {
  background: transparent !important;
  box-shadow: none !important;
}

.login-layout .container-content {
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="scss">
.el-slider__button {
  width: 15px !important;
  height: 15px !important;
  border-color: var(--primary-purple);
}

.el-slider__bar {
  background: linear-gradient(to right, var(--primary-purple), var(--primary-green));
}

.el-slider__runway {
  background: #eaedf3;
}
</style>
